<!-- 登录设置 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea CLoginSetting">
    <!-- 主要头部内容 -->
    <div class="mainHeadContent">
      <!-- 面包屑 -->
      <CBreadCrumb></CBreadCrumb>
    </div>
    <!--主内容区-->
    <div class="mainBodyContent">
      <el-tabs v-model="tabActive">
        <el-tab-pane label="登录" name="1">
          <el-form ref="form" :model="settingform" label-width="130px" class="w500">
            <el-form-item label="登录后展示页面:">
              <el-select class="select" v-model="settingform.show_page" placeholder="请选择">
                <el-option v-for="(item) in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button class="btn-save" type="primary" @click="loginSetting()">保 存</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="支付" name="2" v-if="is_admin == '1'">
          <el-form ref="form" :model="settingform" label-width="130px" class="w500">
            <el-form-item label="微信商户号:">
              <el-input v-model="settingform.mchid" placeholder="WeChat mchid"></el-input>
            </el-form-item>
            <el-form-item label="微信商户支付密钥:">
              <el-input v-model="settingform.merchantKey" placeholder="WeChat merchant key"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button class="btn-save" type="primary" @click="paySetting()">保 存</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <!-- 2019-1-19修改，暂不更新正式 -->
        <el-tab-pane label="广告配置" name="3" v-if="is_admin == '1'">
          <CADConfig></CADConfig>
        </el-tab-pane>
        <el-tab-pane label="客服热线" name="4" v-if="is_admin == '1'">
          <div class="infoTit mb20">
            <div class="title">
              <div class="name">客户服务热线</div>
            </div>
          </div>
          <div class="infoCont">
            <el-form :inline="true" :model="hotlineform" class="demo-form-inline">
              <el-form-item label="客服电话:">
                <el-input v-model="hotlineform.tel" placeholder="客服电话"></el-input>
              </el-form-item>
              <el-form-item label="上班时间:">
                <el-time-picker is-range v-model="hotlineform.time" range-separator="至" start-placeholder="上班时间"
                  end-placeholder="下班时间" placeholder="选择时间范围" value-format="HH:mm" :picker-options="{format:'HH:mm'}">
                </el-time-picker>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="hotlineSetting">保存</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- <el-form ref="form" :model="settingform" label-width="130px" class="w500">
          <template v-if="isfunMap">
          <div class="name">登录设置</div>
          <el-form-item label="登录后展示页面:">
            <el-select class="select" v-model="settingform.show_page" placeholder="请选择">
              <el-option
                v-for="(item) in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          </template>
          <template v-if="is_admin == '1'">
          <div class="name">支付设置</div>
          <el-form-item label="微信APPID:">
            <el-input v-model="settingform.wxAppid" placeholder="微信APPID"></el-input>
          </el-form-item>
          <el-form-item label="微信商户号:">
            <el-input v-model="settingform.mchid" placeholder="WeChat mchid"></el-input>
          </el-form-item>
          <el-form-item label="微信商户支付密钥:">
            <el-input v-model="settingform.merchantKey" placeholder="WeChat merchant key"></el-input>
          </el-form-item>
          <el-form-item label="微信应用密钥:">
            <el-input v-model="settingform.appsecret" placeholder="WeChat APPSECRET"></el-input>
          </el-form-item>
          <el-form-item label="微信支付证书:">
            <el-upload
              class="upload-demo"
              action="fileUrl"
              :http-request="uploadFile"
              :limit="1"
              multiple
              :on-exceed="handleExceed"
              :before-upload="beforeAvatarUpload"
              :on-change="handleChange"
              :file-list="fileList">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="支付宝APPID:">
            <el-input v-model="settingform.payAppid" placeholder="支付宝APP ID"></el-input>
          </el-form-item>
          <el-form-item label="支付宝支付证书:">
            <el-upload
              class="upload-demo"
              action="fileUrl"
              :http-request="uploadFile1"
              :limit="1"
              multiple
              :on-exceed="handleExceed"
              :before-upload="beforeAvatarUpload"
              :on-change="handleChange1"
              :file-list="fileList1">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>
          </template>
          <el-form-item>
            <el-button class="btn-save" type="primary" @click="loginSetting()">保 存</el-button>
          </el-form-item>
        </el-form> -->
    </div>
  </div>
</template>

<script>
import CBreadCrumb from "../Layout/CBreadCrumb.vue"
import CADConfig from "@/components/Page/COther/CADConfig"
import {
  showToast,
  showLoading,
  hideLoading,
  localUserInfo,
} from "../../../../static/js/utility/utility.js"
import { loginApi, userApi, adApi } from "../../../../static/js/api.js"
import * as config from "../../../../static/js/config.js"

export default {
  name: 'CLoginSetting',
  components: {
    CBreadCrumb,
    CADConfig
  },
  data () {
    return {
      is_admin: '',
      settingform: {
        show_page: '',//登录展示页
        wxAppid: '',//微信appid
        mchid: '',//微信商户号
        merchantKey: '',//微信商户支付密钥
        appsecret: '',//微信应用密钥
        payAppid: '',//支付宝APPID
        wxSave_url: '',//微信保存url
        paySave_url: '',//支付宝保存url
      },
      fileUrl: config.address + '/user/uploadImage',//文件上传地址
      fileList: [],//微信证书文件列表
      fileList1: [],//支付宝证书文件列表
      options: [
        {
          // label: '仪表盘',
          label: '数据控制中心',
          value: '1'
        },
        {
          label: '平台默认首页',
          value: '2'
        }
      ],

      isfunMap: false,

      tabActive: '1',//tab当前选中

      hotlineform: {
        tel: '',//客服电话
        time: ['09:00:00', '18:00:00'],//上下班时间
      },
    }
  },
  mounted () {
  },
  created: async function () {
    this.isfunMap = this.$store.state.isfunMap
    if (!this.isfunMap) { this.options.splice(0, 1) }
    let show_page = JSON.parse(localStorage.getItem('eUserInfo')).show_page
    this.settingform.show_page = show_page
    this.is_admin = localUserInfo.getItem().is_admin

    this.getPayConfig()
  },
  methods: {
    //获取登录设置信息
    async getPayConfig () {
      let that = this;
      const res = await userApi.getPayConfig()
      if (res.meta.code === 200) {
        if (res.data) {
          that.settingform.mchid = res.data.merchant_id
          that.settingform.merchantKey = res.data.pay_key
        }
      } else {
        showToast(res.meta.message)
        // that.$message.error(res.meta.message)
      }
    },
    //上传文件
    async uploadFile1 (param) {
      let that = this
      let formData = new FormData()
      formData.append('file', param.file)
      formData.append('type', 'pem')
      let res = await userApi.uploadImage(formData)
      if (res.meta.code === 200) {
        // that.addform.show_url = res.data.show_url
        that.settingform.paySave_url = res.data
      } else {
        showToast(res.meta.message)
        // that.$message.error(res.meta.message)
      }
    },
    handleChange1 (file, fileList) {
      this.fileList1 = fileList.slice(-1);
    },
    //上传文件校验
    beforeAvatarUpload (file) {
      const isLt1M = file.size / 1024 < 100;
      if (!isLt1M) {
        showToast('上传文件大小不能超过 100KB!')
        // this.$message.error('上传文件大小不能超过 100KB!');
      }
      return isLt1M;
    },
    //上传文件
    async uploadFile (param) {
      let that = this
      let formData = new FormData()
      formData.append('file', param.file)
      formData.append('type', 'pem')
      let res = await userApi.uploadImage(formData)
      if (res.meta.code === 200) {
        // that.addform.show_url = res.data.show_url
        that.settingform.wxSave_url = res.data
      } else {
        showToast(res.meta.message)
        // that.$message.error(res.meta.message)
      }
    },
    handleChange (file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    handleExceed (files, fileList) {
      showToast('只能上传1个文件！')
      // this.$message.warning('只能上传1个文件！')
    },
    //上传文件校验
    beforeAvatarUpload (file) {
      const isLt1M = file.size / 1024 < 100;
      if (!isLt1M) {
        showToast('上传文件大小不能超过 100KB!')
        // this.$message.error('上传文件大小不能超过 100KB!');
      }
      return isLt1M;
    },
    // 改变show_page，更新eUserInfo
    updateUserInfo: function (new_show_page) {
      let newUserInfo = JSON.parse(localStorage.getItem('eUserInfo'))
      newUserInfo.show_page = new_show_page
      localStorage.setItem('eUserInfo', JSON.stringify(newUserInfo))
    },
    // 登录设置
    loginSetting: async function () {
      let that = this
      let data = {
        'show_page': this.settingform.show_page,//登录页设置
      }
      showLoading('保存设置中')
      let res = await loginApi.loginSetting(data)
      hideLoading()
      if (res.meta.code === 200) {
        showToast('设置成功')
        that.updateUserInfo(data.show_page)
      } else {
        showToast(res.meta.message)
      }
    },
    // 支付设置
    paySetting: async function () {
      let that = this
      let data = {
        'merchant_id': this.settingform.mchid,//微信商户号
        'pay_key': this.settingform.merchantKey,//微信商户支付密钥
      }
      showLoading('保存设置中')
      let res = await loginApi.paySetting(data)
      hideLoading()
      if (res.meta.code === 200) {
        showToast('设置成功')
        that.getPayConfig();
      } else {
        showToast(res.meta.message)
      }
    },
    // 获取客服热线信息
    async getHotline () {
      let vm = this
      let res = await adApi.getHotline()
      if (res.meta.code === 200) {
        vm.hotlineform.tel = res.data.hotline
        vm.hotlineform.time = [res.data.hotline_start_time, res.data.hotline_end_time]
      } else {
        showToast(res.meta.message)
      }
    },
    // 客服热线配置
    async hotlineSetting (e) {
      let vm = this
      let data = {
        hotline: vm.hotlineform.tel,
        hotline_start_time: vm.hotlineform.time[0],
        hotline_end_time: vm.hotlineform.time[1]
      }
      console.log(data)
      if (data.hotline === '') {
        showToast('请填写客服电话')
        return
      }

      showLoading('保存中')
      let res = await adApi.hotlineSetting(data)
      hideLoading()
      if (res.meta.code === 200) {
        showToast('保存成功')
      } else {
        showToast(res.meta.message)
      }
    },
  },
  watch: {
    // 监听vuex的值变化
    "tabActive": async function (newVal, oldVal) {
      //console.log(newVal)
      // 获取客服信息
      if (newVal == 4) {
        this.getHotline()
      }
    },
    '$store.state.isfunMap': function (newVal) {
      var that = this
      this.isfunMap = newVal
      if (!newVal) {
        this.options.splice(0, 1)
        if (that.is_admin == '1') {
          that.tabActive = '2'
        } else {
          that.tabActive = '3'
        }
      } else {
        // this.options.unshift({label: '仪表盘', value: '1'})
        this.options.unshift({ label: '数据控制中心', value: '1' })
      }
    }
  }
}
</script>

<style lang="scss">
.CLoginSetting {
  .infoTit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .name {
      font-size: 20px;
      color: #000;
    }
    p {
      color: #f56c6c;
      font-size: 14px;
      margin-bottom: 10px;
    }
  }
  .infoCont {
    margin-bottom: 20px;
  }
  .mb20 {
    margin-bottom: 20px;
  }
  .mr10 {
    margin-right: 10px;
  }
  .w500 {
    width: 500px;
  }
  .lable {
    float: left;
    line-height: 40px;
  }
  .selectBox {
    margin-left: 130px;
    .select {
      margin-bottom: 20px;
    }
    .btn-save {
      display: block;
    }
  }
  // tabs标签
  .el-tabs__header {
    width: 100%;
    margin-bottom: 20px;
    box-sizing: border-box;
    border-bottom: 1px solid #e4e7ed;
    .el-tabs__nav-wrap {
      padding-left: 20px;
      width: 360px;
    }
    .el-tabs__item {
      font-size: 18px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/COther/CLoginSetting.vue